import { SHOP_UPSELL_SESSION_KEY } from "./shop.config";

/** Call right before navigating to Orders after a successful costume booking. */
export const markShopUpsellPending = (): void => {
  try {
    sessionStorage.setItem(SHOP_UPSELL_SESSION_KEY, "1");
  } catch {
    // ignore quota / private-mode failures
  }
};

/** Read + clear the one-shot post-booking flag. */
export const consumeShopUpsellPending = (): boolean => {
  try {
    const pending = sessionStorage.getItem(SHOP_UPSELL_SESSION_KEY) === "1";
    if (pending) {
      sessionStorage.removeItem(SHOP_UPSELL_SESSION_KEY);
    }
    return pending;
  } catch {
    return false;
  }
};
